import React from 'react';
import { ZoomIn } from 'lucide-react';

interface Props {
  name: string;
  color: string;
  count: number;
  isHidden: boolean;
  onToggle: (name: string) => void;
  onZoom: (name: string) => void;
}

export const LegendItem: React.FC<Props> = ({ name, color, count, isHidden, onToggle, onZoom }) => {
  return (
    <li className="w-full list-none flex items-center hover:bg-bg-raised group/item">
      <button
        type="button"
        onClick={() => onToggle(name)}
        title={name}
        className="flex-1 min-w-0 text-left flex items-center gap-2 px-[14px] py-[5px] cursor-pointer select-none transition-colors"
      >
        <span
          className="size-[7px] rounded-full flex-shrink-0 transition-opacity"
          style={{ backgroundColor: color, opacity: isHidden ? 0.15 : 0.75 }}
        />
        <span
          className="flex-1 text-[10.5px] text-text-secondary whitespace-nowrap overflow-hidden text-ellipsis transition-opacity"
          style={{ opacity: isHidden ? 0.2 : 1 }}
        >
          {name}
        </span>
        <span className="text-[10px] text-text-muted flex-shrink-0">{count}</span>
      </button>
      <button
        type="button"
        onClick={() => onZoom(name)}
        aria-label={`Zoom to ${name}`}
        className="hidden desk:flex flex-shrink-0 items-center pr-[10px] pl-[2px] py-[5px] text-text-muted opacity-0 group-hover/item:opacity-100 transition-opacity cursor-pointer hover:text-text-secondary"
      >
        <ZoomIn size={10} aria-hidden="true" />
      </button>
    </li>
  );
};
